export const PRIMARY_BLACK = "#101214";
export const SAMPLE_PROJECT_KEY = "sampleProject";
export const CREATE_PROJECT_KEY = "createProject";
